/**
 * Punto unico di lettura delle variabili d'ambiente.
 * REGOLA: nessun file fuori da qui legge `import.meta.env` direttamente.
 */

const bool = (value, fallback = false) => (value === undefined ? fallback : String(value) === 'true')

export const APP_NAME = import.meta.env.VITE_APP_NAME || 'Kris Agent'

/** Ambiente mostrato nella topbar: local, staging o production. */
export const APP_ENV = import.meta.env.VITE_APP_ENV || 'local'

export const API_BASE_URL = import.meta.env.VITE_API_URL || '/api/v1'

/**
 * Login finto per lo sviluppo locale: nessun Firebase. Le chiamate vanno comunque
 * all'API vera, con i token `mock:<utente>:<ruoli>` che l'API accetta solo con
 * AUTH_MOCK_ENABLED=true (in .dev.vars, mai in staging o produzione).
 */
export const MOCK_AUTH = bool(import.meta.env.VITE_MOCK_AUTH, true)

export const FIREBASE_CONFIG = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
}

export const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID

/** Ruoli conosciuti dall'app. Usati in `meta.roles` delle rotte e nel menu. */
export const ROLES = {
  ADMIN: 'admin',
  USER: 'user',
}

/** Fuso orario in cui l'admin inserisce e legge le date degli abbonamenti. */
export const TIME_ZONE = 'Europe/Rome'
